// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MuiTableCell-root{color:#343233 !important}", "",{"version":3,"sources":["webpack://./src/ui/containers/admin/role-permissions/style.scss"],"names":[],"mappings":"AAAA,mBACI,wBAAA","sourcesContent":[".MuiTableCell-root {\r\n    color: #343233 !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
